module.exports = __webpack_public_path__ + "img/01.fb24bd5d.webp";